// Map a system-audit action to an icon + tone, so activity feeds and the audit
// grid read at a glance (shared by the Overview dashboard + the Audit page).
import {
  Building2, Trash2, Pause, Play, CreditCard, KeyRound, FileText, ShieldCheck,
  UserPlus, UserMinus, UserCog, RefreshCw, FlaskConical, Settings2, LogIn, Circle,
  type LucideIcon,
} from 'lucide-react';

export function activityIcon(action: string): { Icon: LucideIcon; tone: string } {
  const a = action.toLowerCase();
  if (a.includes('provision') || a === 'tenant.create') return { Icon: Building2, tone: 'text-primary' };
  if (a.includes('retry')) return { Icon: RefreshCw, tone: 'text-warning' };
  if (a.includes('delete') || a.includes('erase')) return { Icon: Trash2, tone: 'text-critical' };
  if (a.includes('unsuspend')) return { Icon: Play, tone: 'text-ok' };
  if (a.includes('suspend')) return { Icon: Pause, tone: 'text-warning' };
  if (a.includes('subscription') || a.includes('invoice') || a.includes('billing')) return { Icon: CreditCard, tone: 'text-ok' };
  if (a.includes('api') && a.includes('key')) return { Icon: KeyRound, tone: 'text-muted' };
  if (a.includes('export')) return { Icon: FileText, tone: 'text-primary' };
  if (a.includes('user.remove') || a.includes('removeuser')) return { Icon: UserMinus, tone: 'text-warning' };
  if (a.includes('user.role') || a.includes('setrole')) return { Icon: UserCog, tone: 'text-muted' };
  if (a.includes('admin') || a.includes('invite') || a.includes('user.create')) return { Icon: UserPlus, tone: 'text-ok' };
  if (a.includes('totp') || a.includes('security') || a.includes('2fa')) return { Icon: ShieldCheck, tone: 'text-primary' };
  if (a.includes('impersonate')) return { Icon: LogIn, tone: 'text-warning' };
  if (a.includes('flag')) return { Icon: FlaskConical, tone: 'text-muted' };
  if (a.includes('edit') || a.includes('update') || a.includes('settings')) return { Icon: Settings2, tone: 'text-muted' };
  return { Icon: Circle, tone: 'text-muted' };
}
